import React from 'react';
import moment from 'moment';
import { Popover, Icon, Divider } from 'antd';

const SyncTime = props => {
  const { t, time, link, history } = props;

  const handleLinkClick = e => {
    e.preventDefault();
    if (history && link) {
      history.push(link);
    }
  };

  return (
    <>
      <span className="sync-status__label">{t('cms:cms.property.last_sync')}</span>
      <span className="sync-status__value sync-status__time">
        {time ? moment(time).format('HH:mm:ss YYYY-MM-DD') : '-'}
      </span>
      <Popover content={t('cms:cms.property.last_sync.timezone')}>
        <button className="sync-status__question">
          <Icon type="question-circle" />
        </button>
      </Popover>
      {link && (
        <>
          <Divider type="vertical" style={{ margin: '0 12px' }} />
          <a className="sync-status__link" href="#" onClick={handleLinkClick}>
            {t('cms:cms.property.last_sync.change_log')}
          </a>
        </>
      )}
    </>
  );
};

export default SyncTime;
